var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"prominent":"","type":"error","dismissible":""}},[_c('h2',[_vm._v("Leider ist ein Fehler aufgetreten:")]),_c('p',[_vm._v(_vm._s(_vm.error))])])
}
var staticRenderFns = []

export { render, staticRenderFns }